// Autogenerated file
export const billingPaymentTypesEnum = {
    PrePayment: "PrePayment",
    PostPayment: "PostPayment",
};
export const billingPaymentTypes = [
    { label: "Предоплата", value: "PrePayment" },
    { label: "Постоплата", value: "PostPayment" },
];
